/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const SearchShortcutIcon = ({size, ...props}) => (
  <svg viewBox="0 0 18 18" fill="currentColor" width={ size || "18" } height={ size || "18" } {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="17" height="17" x=".5" y=".5" stroke="#C0C5CE" rx="8.5" />
      <text fill="#A7A9B2" fontFamily="HelveticaNeueW01-65Medium, Helvetica Neue W01 65 Medium" fontSize="13">
        <tspan x="7" y="14">/</tspan>
      </text>
    </g>
  </svg>
);
SearchShortcutIcon.displayName = 'SearchShortcutIcon';
SearchShortcutIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
